<template>
    <vueCustomScrollbar
      class="scroll-area p-2"
      :settings="{wheelSpeed:0.5}"
      v-if="company"
    >
      <h3 class="mb-3">Company details</h3>
      <p>
        <b>id:</b> {{cid}}<br>
        <b>date:</b> {{company.data().date.toMillis() | moment('lll')}}<br>
        <b>name:</b> {{company.data().name}}<br>
        <b>description:</b> {{company.data().description}}<br>
        <b>server_token:</b> {{company.data().server_token}}<br>
      </p>
      <hr>

      <applicationsList
        :company="company"
        :activeApplication="activeApplication"
        @selectApplication="$emit('selectApplication',$event)"
      />
      <hr>
      <campaignsList
        :company="company"
        :activeCampaign="activeCampaign"
        @selectCampaign="$emit('selectCampaign',$event)"
      />

    </vueCustomScrollbar>
</template>

<script>
import firebase from 'firebase';
import vueCustomScrollbar from 'vue-custom-scrollbar'
import campaignsList from './campaignsList.vue'
import applicationsList from './applicationsList.vue'

export default {
  name: 'companyDetail',
  props:{
    cid:{
      type:String,
      required:true,
    },
    activeCampaign:{
      default:null
    },
    activeApplication:{
      default:null
    }
  },
  components: {
    vueCustomScrollbar,
    campaignsList,
    applicationsList,
  },
  data:function(){
    return {
      company:null,
    }
  },
  watch:{
    cid:{
      handler:function() { 
        firebase.firestore()
          .collection("companies")
          .doc(this.cid)
          .onSnapshot((company)=>{
            this.company = company;
          });
      },
      immediate:true,
    }
  }
}
</script>
<style scoped>
.scroll-area{
  height: 100vh !important;
}
.scroll-area.ps--active-y{
  padding-right: 12px !important;
}
</style>